/* ★ SCENE OUTPUT — Control Panel tab Flow (enjin RESIPI, 17 Okt 2026, PLAN_FLOW_RESIPI.md).
 *
 * Pilihan pelanggan untuk module berbilang scene (3–5) yang menuntut enjin `resipi`:
 *   'gabung' — semua scene digabung jadi SATU video (Scenebuilder) → masuk card (lalai)
 *   'asing'  — setiap scene dimuat turun sebagai fail sendiri ke folder Downloads; card TIDAK memapar
 *              video itu dan ditanda separuh siap (flow_partial) supaya tidak masuk barisan TikTok tanpa video
 *              (keputusan user 17 Okt).
 * Laluan nilai: App.jsx `hasilScene` (useState, dipulihkan malas dari storan ini) → prop KEDUA-DUA render
 *   WorkspaceView → payload Run Flow `settings.flowSceneOutput` → jambatan extension menyalin `settings`
 *   bulat-bulat → skrip remote flow-automation-resipi.js (`_resipiBaca`).
 * Simpanan per-browser SENDIRI (corak `sesaat_cara_post_v1`), ditulis HANYA dalam pengendali pilihan —
 *   bukan effect (perangkap StrictMode localhost, webapp.md §6).
 * ⚠️ KEMBAR nilai: skrip flow-resipi/20-resipi.js `RESIPI_HASIL` (robot juga kenal 'keduanya' — untuk ujian,
 *   tidak ditawarkan kepada pelanggan).
 */

export const HASIL_SCENE = ['gabung', 'asing'];
const KUNCI = 'sesaat_hasil_scene_v1';

export function normHasilScene(v) {
    return HASIL_SCENE.includes(v) ? v : 'gabung';
}

export function bacaHasilScene() {
    try { return normHasilScene(localStorage.getItem(KUNCI)); } catch { return 'gabung'; }
}

export function simpanHasilScene(v) {
    const n = normHasilScene(v);
    try { localStorage.setItem(KUNCI, n); } catch { /* storan ditutup — abai */ }
    return n;
}
